/**
 * @author: Ashay Tiwari
 * @date: 11 July 2021
 * @description: File for Student Signup Page 5 Action Types
 * @developedBy: Kritin Digital Solutions Pvt. Ltd.
 */
export const STUDENT_WORK_EXPERIENCE = "STUDENT_WORK_EXPERIENCE";
export const STUDENT_ABROAD_EXPERIENCE = "STUDENT_ABROAD_EXPERIENCE";
export const STUDENT_CERTIFICATE = "STUDENT_CERTIFICATE";
